import { StyleSheet } from 'lib/paypalphrodite'

const lightGrey = '#dedede'
const darkGrey = '#6c7378'

export default StyleSheet.create({
  noteWrapper: {
    boxSizing: 'border-box',
    borderTop: `1px solid ${lightGrey}`,
    position: 'relative',
    transition: 'height 1000ms ease',
  },
  disabledAndEmptyNoteWrapper: {
    borderTop: 0,
    borderBottom: 0,
  },
  displayHidden: {
    display: 'none',
  },
  donateNoteWrapper: {
    borderTop: 0,
  },
  label: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'transform 350ms ease, opacity 350ms ease',
  },
  labelContentsWrapper: {
    position: 'absolute',
    top: '28%',
  },
  rtrLabelContentsWrapper: {
    top: '15%',
  },
  labelText: {
    display: 'inline',
    color: darkGrey,
    padding: 0,
    margin: 0,
  },
  labelTextBig: {
    display: 'inline',
    fontSize: 16,
    lineHeight: '1.6rem',
    fontWeight: 'normal',
    color: darkGrey,
    padding: 0,
    margin: 0,
  },
  labelSvg: {
    display: 'inline',
    height: 14,
    width: 14,
    marginTop: 6,
    marginRight: 10,
    fill: 'none',
    stokeWidth: 1,
    stroke: darkGrey,
  },
  textArea: {
    width: '100%',
    minHeight: 60, // NOTE this forces the auto-sizing textarea to be at least this tall
    maxHeight: 140, // NOTE this forces the auto-sizing textarea to be no taller than this
    border: 0,
    padding: 10,
    resize: 'none',
    boxSizing: 'border-box',
    outline: 'none',
  },
  transitionOut: {
    transform: 'translateY(5px)',
    opacity: '0',
  },
  noSize: {
    top: 'auto',
    right: 'auto',
  },
  editIcon: {
    color: darkGrey,
    // center vertically
    position: 'relative',
    top: '2px',
  },
  rtrEditIcon: {
    verticalAlign: 'top',
    top: '3px',
  },
  rtrNoteLabelText: {
    display: 'inline-block',
    textAlign: 'left',
  },
  rtrNoteENSubText: {
    fontSize: '14px',
  },
  paypalTextArea: {
    border: 'none',
  },
})
